import * as actionTypes from 'actions/actionTypes'

const initialState = {
  loading: false,
}

const loadingReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case actionTypes.START_REQUEST:
      return {
        ...state,
        loading: true
      }
    case actionTypes.FINISH_REQUEST:
      return {
        ...state,
        loading: false
      }
    default:
      return state
  }
}

export default loadingReducer



// WEBPACK FOOTER //
// ./src/store/reducers/loadingReducer.js